/** «Огляд» — the morning dashboard (ADR-0009). Business cards' keys stay in ./businesses. */
export const overview = {
  'overview.intro': 'Що чекає вас, що сьогодні і що зрушило за добу. Зібрано о {time}.',
  'overview.waiting.title': 'Чекають мене',
  'overview.waiting.none': 'Нічого не чекає на вас.',
  'overview.waiting.fromDialog': 'з розмови «{title}»',
  'overview.waiting.fromInbox': 'з Вхідної «{title}»',
  'overview.waiting.sviteya': 'Тікети Sviteya на вас',
  'overview.waiting.sviteyaSince': 'на вас з {date}',
  'overview.waiting.more': 'Ще {n} — у дошці Sviteya',
  'overview.today.title': 'Сьогодні',
  'overview.today.noCalendar': 'Календар ще не прочитано: його приносить розбирач о 8:00.',
  'overview.today.noEvents': 'Зустрічей немає.',
  'overview.today.allDay': 'весь день',
  'overview.today.deadlines': 'Терміни',
  'overview.today.overdue': 'прострочено',
  'overview.today.queueNow': 'У черзі «зараз»: {n}',
  'overview.today.allTasks': 'усі задачі',
  'overview.dialogs.title': 'Розмови',
  'overview.dialogs.counts': 'Працюють {working} · Чекають на вас {waiting} · Зависли {stale}',
  'overview.dialogs.none': 'Жодна розмова не чекає й не зависла.',
  'overview.stuck.title': 'Зависло',
  'overview.stuck.hint': 'в роботі без руху понад 5 днів',
  'overview.stuck.none': 'Нічого не зависло.',
  'overview.stuck.meta': 'без руху {days} дн. · з {date}',
  'overview.sviteya.title': 'Рух Sviteya',
  'overview.sviteya.hint': 'за добу · прочитано {when}',
  'overview.sviteya.never': 'ще не прочитано',
  'overview.sviteya.kpi.moved': 'Змінили стан',
  'overview.sviteya.kpi.created': 'Нових',
  'overview.sviteya.kpi.review': 'На перевірці',
  'overview.sviteya.kpi.onOlena': 'На вас',
  'overview.sviteya.moved': 'Що змінило стан',
  'overview.sviteya.movedNone': 'За добу нічого не змінило стан.',
  'overview.sviteya.col.code': 'Тікет',
  'overview.sviteya.col.title': 'Назва',
  'overview.sviteya.col.move': 'Було → стало',
  'overview.sviteya.col.at': 'Коли',
  'overview.sviteya.longest': 'Найдовше на перевірці',
  'overview.sviteya.reviewSince': 'на перевірці з {date}',
  'overview.sviteya.error': 'Останнє читання дошки не вдалося: {error}',
  'overview.sviteya.connectTitle': 'Підключити дошку Sviteya',
  'overview.sviteya.connectText': 'Офіс читатиме дошку задач Sviteya щогодини й показуватиме тут, що зрушило. Нічого в Sviteya не змінюється. Після натискання відкриється Sviteya: увійдіть і натисніть «Дозволити».',
  'overview.sviteya.address': 'Адреса Sviteya',
  'overview.sviteya.business': 'Бізнес',
  'overview.sviteya.connect': 'Підключити',
  'overview.sviteya.reconnect': 'Підключити знову',
  'overview.sviteya.connected': 'Дошку Sviteya підключено. Перше читання — за хвилину.',
  'overview.sviteya.denied': 'Підключення до Sviteya скасовано.',
  'overview.sviteya.failed': 'Не вдалося підключити дошку Sviteya. Спробуйте ще раз.',
  'overview.sviteya.status.backlog': 'черга',
  'overview.sviteya.status.in_progress': 'в роботі',
  'overview.sviteya.status.review': 'на перевірці',
  'overview.sviteya.status.accepted': 'прийнято',
  'overview.sviteya.status.deferred': 'відкладено',
  'overview.sviteya.status.rejected': 'відхилено',
  'overview.sviteya.status.on_olena': 'на Олені',
  'overview.inbox.title': 'Вхідна',
  'overview.inbox.counts': 'Нового {new} · Потрібні ви {needs} · Розібрано сьогодні {sorted}',
  'overview.inbox.you': 'ви',
  'overview.knowledge.title': 'Знання за тиждень',
  'overview.directions.title': 'Напрями',
  'overview.directions.hint': 'Зараз — заплановано, в роботі, на перевірці, чекає людину. Далі — черга. Колись — відкладено.',
  'overview.directions.col.project': 'Проєкт',
  'overview.directions.col.now': 'Зараз',
  'overview.directions.col.next': 'Далі',
  'overview.directions.col.later': 'Колись',
  'overview.directions.col.nextTask': 'Наступна задача',
  'overview.directions.noProject': 'Без проєкту',
} as const;
